<template>
  <div style="margin: 0 auto;width: 100%;">
    <Header/>
    <ActivityIndex/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header'
import ActivityIndex from './components/ActivityIndex'
import Footer from '../layout/Footer'
export default {
  components: {
    Header,
    ActivityIndex,
    Footer
  },
  data () {
    return {
      programId: Number(this.$route.query.programId)
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/ActivityIndex.vue